const ScreenTypes = {
	LAPTOP: { type: 1, isSmall: false },
	TABLET: { type: 2, isSmall: true },
	MOBILE: { type: 3, isSmall: true },
};

export default ScreenTypes;
